/* ==========================================================
   NSG FRAMEWORK
   Component: nsg-hero-premium
   Version: 3.0.0
   ========================================================== */

(function () {
  function initHero(hero) {
    if (!hero || hero.dataset.nsgHeroInitialized === 'true') return;

    var isCarousel = hero.dataset.carousel === 'true';
    if (!isCarousel) return;

    var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-nsg-hero-slide]'));
    var dots = Array.prototype.slice.call(hero.querySelectorAll('[data-nsg-hero-dot]'));
    var prev = hero.querySelector('[data-nsg-hero-prev]');
    var next = hero.querySelector('[data-nsg-hero-next]');
    var autoplay = hero.dataset.autoplay === 'true';
    var autoplaySpeed = parseInt(hero.dataset.autoplaySpeed || '5000', 10);
    var current = 0;
    var timer = null;
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (slides.length <= 1) return;

    hero.dataset.nsgHeroInitialized = 'true';

    function goTo(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;

      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');

      current = index;

      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      if (!autoplay || prefersReducedMotion) return;
      stop();
      timer = window.setInterval(function () {
        goTo(current + 1);
      }, autoplaySpeed);
    }

    if (prev) {
      prev.addEventListener('click', function () {
        goTo(current - 1);
        start();
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        goTo(current + 1);
        start();
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(dot.dataset.nsgHeroDot, 10);
        goTo(index);
        start();
      });
    });

    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);

    var touchStartX = 0;
    var touchEndX = 0;

    hero.addEventListener('touchstart', function (event) {
      touchStartX = event.changedTouches[0].screenX;
    }, { passive: true });

    hero.addEventListener('touchend', function (event) {
      touchEndX = event.changedTouches[0].screenX;
      var diff = touchStartX - touchEndX;

      if (Math.abs(diff) > 50) {
        if (diff > 0) {
          goTo(current + 1);
        } else {
          goTo(current - 1);
        }
        start();
      }
    }, { passive: true });

    start();
  }

  function initAll() {
    document.querySelectorAll('[data-nsg-hero]').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event && event.target) {
      event.target.querySelectorAll('[data-nsg-hero]').forEach(initHero);
    }
  });
})();
